import React, {useState} from 'react';
import AgeRestrictedContext from "../../../../services/Common/AgeRestrictedContext";
import AgeRestrictedModalComponent from "./AgeRestrictedModalComponent";


interface OwnProps {
    children: React.ReactNode;
}

const AgeRestrictedComponent = ({children}: OwnProps) => {
    const [showAgeRestricted, setShowAgeRestricted] = useState(!AgeRestrictedContext.isAccepted() && AgeRestrictedContext.isAlcohol());
    return (
        <>
            {showAgeRestricted ? (
                <>
                    <div>
                        <AgeRestrictedModalComponent show={true} onSave={() => {
                            setShowAgeRestricted(false)
                        }}/>
                    </div>
                </>
            ) : (
                <>
                    {children}
                </>
            )};
        </>
    )
}

export default AgeRestrictedComponent;
